import React, { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { showSessionLinks } from '~/actions/recents'
import useKeyboardAction from '~/components/hooks/use-keyboard-action'
import { translate } from '~/core/translate'
import { BoxTitle } from '../styled'
import LinksList from './list'
import Button from '@8x8/oxygen-button'
import { FUNCTIONS } from '~/core/constants'
import { RESOURCE_TYPE_MAPPINGS } from './configs'
import Box from '../box'

const StyledBox = styled(Box)`
  cursor: ${({ disabled }) => disabled ? 'auto' : 'pointer'};
  padding-bottom: 0;

  &:hover {
    ${({ disabled, theme }) => disabled && `background-color: ${theme._neo.ui02}`};
  }
`

const StyledLoadMoreButton = styled(Button)`
  margin: 8px auto;
`

const Links = ({ className, id, inPreviewMode, resourceType }) => {
  const resourceTypeData = RESOURCE_TYPE_MAPPINGS[resourceType]
  const linksListRef = useRef()
  let hasMoreItems
  if (resourceTypeData.hasMoreSelector !== FUNCTIONS.NULL) {
    hasMoreItems = useSelector(resourceTypeData.hasMoreSelector(id))
  }
  let links = useSelector(resourceTypeData.itemsSelector(id))
  const dispatch = useDispatch()
  const linksCount = links.length

  const handleBoxClick = () => {
    if (shouldShowModal) {
      dispatch(showSessionLinks(id, resourceType))
    }
  }

  const onMoreButtonClick = () => {
    if (resourceTypeData.fetchMoreItemsAction !== FUNCTIONS.NOOP) {
      dispatch(resourceTypeData.fetchMoreItemsAction())
      linksListRef.current?.focus()
    }
  }

  const handleLoadMoreKeyUp = useKeyboardAction(onMoreButtonClick)

  if (!links.length) {
    return null
  }

  if (inPreviewMode) {
    const [first, second] = links
    links = [first, second].filter(Boolean)
  }

  const shouldShowModal = inPreviewMode && linksCount > 2

  return (
    <div className={className}>
      <BoxTitle>{translate(resourceTypeData.titleTranslateKey)}</BoxTitle>
      <StyledBox
        callback={handleBoxClick}
        disabled={!shouldShowModal}
        {...(shouldShowModal ? { 'aria-label': translate(resourceTypeData.titleTranslateKey) } : {})}
      >
        <LinksList
          columns={links.length > 2 ? 2 : 1}
          disabled={shouldShowModal}
          links={links}
          linkClickedCallback={resourceTypeData.linkClickedCallback}
          ref={linksListRef}
        />
        {resourceTypeData.fetchMoreItemsAction !== FUNCTIONS.NOOP &&
          !inPreviewMode &&
          hasMoreItems && (
            <StyledLoadMoreButton
              onClick={onMoreButtonClick}
              onKeyUp={handleLoadMoreKeyUp}
              variant='secondary'
              size='small'
            >
              {translate('load_more_items')}
            </StyledLoadMoreButton>
        )}
      </StyledBox>
    </div>
  )
}

export default styled(Links)``
